/*
  Falken Shopify Theme - Custom JavaScript
*/

(function() {
  'use strict';

  // Initialize when DOM is ready
  document.addEventListener('DOMContentLoaded', function() {
    initThemeSwitcher();
    initAddToCart();
    initQuantityInputs();
    initBackToTop();
  });

  // Theme switcher (light/dark mode)
  function initThemeSwitcher() {
    const themeSwitcher = document.querySelector('#theme-mode');
    if (!themeSwitcher) return;

    // Set initial state
    const currentTheme = localStorage.getItem('theme-mode') || 'light';
    themeSwitcher.checked = currentTheme === 'dark';

    themeSwitcher.addEventListener('change', function() {
      const newTheme = this.checked ? 'dark' : 'light';
      document.documentElement.setAttribute('data-bs-theme', newTheme);
      localStorage.setItem('theme-mode', newTheme);
    });
  }

  // Add to cart functionality
  function initAddToCart() {
    document.querySelectorAll('[data-add-to-cart]').forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        const variantId = this.dataset.addToCart;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [{
              id: parseInt(variantId),
              quantity: 1
            }]
          })
        })
        .then(response => response.json())
        .then(data => {
          updateCartCount();
          openCartDrawer();
        })
        .catch(error => {
          console.error('Error adding to cart:', error);
        });
      });
    });
  }

  // Quantity input controls
  function initQuantityInputs() {
    document.querySelectorAll('[data-increment], [data-decrement]').forEach(function(button) {
      button.addEventListener('click', function() {
        const container = this.closest('.count-input');
        if (!container) return;

        const input = container.querySelector('input[type="number"]');
        if (!input) return;

        let value = parseInt(input.value) || 0;

        if (this.hasAttribute('data-increment')) {
          value++;
        } else if (this.hasAttribute('data-decrement') && value > 0) {
          value--;
        }

        input.value = value;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  // Update cart count in header
  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        document.querySelectorAll('.cart-count').forEach(function(el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(error => {
        console.error('Error fetching cart:', error);
      });
  }

  // Open cart drawer
  function openCartDrawer() {
    const cartOffcanvas = document.getElementById('cartOffcanvas');
    if (cartOffcanvas && typeof bootstrap !== 'undefined') {
      const bsOffcanvas = new bootstrap.Offcanvas(cartOffcanvas);
      bsOffcanvas.show();
    }
  }

  // Back to top button
  function initBackToTop() {
    const backToTop = document.querySelector('.btn-scroll-top');
    if (!backToTop) return;

    window.addEventListener('scroll', function() {
      if (window.pageYOffset > 600) {
        backToTop.classList.add('show');
      } else {
        backToTop.classList.remove('show');
      }
    });

    backToTop.addEventListener('click', function(e) {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  }

  // Shopify money formatting helper
  window.Shopify = window.Shopify || {};
  window.Shopify.formatMoney = function(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }

    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '${{amount}}';

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision || 2;
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };

})();
